<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 346.1 226.7"
    style="enable-background:new 0 0 346.1 226.7;"
    xml:space="preserve"
    class="rect_svg"
  >
    <title>{{$t('titles.rectangle')}}</title>
    <rect class="rect_tool" width="346.1" height="226.7"></rect>
    <linearGradient
      id="SVGID_rectangle"
      gradientUnits="userSpaceOnUse"
      x1="297.37"
      y1="-64.54"
      x2="36.48"
      y2="-64.54"
      gradientTransform="matrix(1 0 0 -1 0 47.92)"
    >
      <stop offset="0" style="stop-color:#28BCB5"></stop>
      <stop offset="1" style="stop-color:#59B954"></stop>
    </linearGradient>
    <rect x="39" y="31" class="rect_tool_1" width="255.9" height="162.9"></rect>
  </svg>
</template>
<script>
export default {
  name: "rectangleTool"
};
</script>

<style>
.rect_tool {
  fill: #252624;
}
.rect_tool_1 {
  fill: none;
  stroke: url(#SVGID_rectangle);
  stroke-width: 5;
  stroke-miterlimit: 10;
}
.rect_svg {
  position: absolute;
  background: transparent;
  width: 86px;
  height: 100px;
  top: -45px;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  left: -16px;
}
</style>
